import React, { Component } from 'react';
import { Link } from 'react-router-dom'
import Slider from 'react-slick';
import Modal from 'react-responsive-modal';
import ReactPlayer from 'react-player/lazy'

import { influncers } from "../../../services/script"
import { topCategoryScrollAuto } from '../../../services/script'

class Influencer extends Component {

    constructor(props) {
        super(props)
        this.video = React.createRef();

        this.state = {
            open: false,
            link: null
        }
    }

    onOpenModal = (url) => {
        this.setState({ open: true });
        this.setState({ link: url });
        
    };

    onCloseModal = () => {
        this.setState({ open: false });
    };

    render() {

        const { type, influences, themeLayoutId, InfluencerText } = this.props;

        return (
            <>
             {
                themeLayoutId !== 'L02' || themeLayoutId !== 'L03' &&

            <section className={`instagram`} style={{ paddingBottom: 50, paddingTop: 15 }}>
                <div className="title1  section-t-space" style={{ paddingTop: 0 }}>
                    {/* <h4>special offer</h4> */}
                    <h2 className="title-inner1">Influencers</h2>
                </div>
                <div className={'container'}>
                    <div className="row">
                        <div className="col-md-12 p-0">
                            {/* <h2 className="title-borderless"></h2> */}
                            <Slider {...influncers} className="slide-7 no-arrow slick-instagram">
                                {
                                    influences.map((influence, index) => {
                                        return (
                                            <div key={index} className="product-box"> 
                                                <div className="img-wrapper">
                                                    <div className="lable-block">
                                                        {/* {(product.Title.APC_ELEMENT_CONTENT) ? <span className="lable5"> {product.Title.APC_ELEMENT_CONTENT}   </span> : ''} */}
                                                         <span className="lable6">  {influence.AIM_INFLUENCER_NAME} </span>                                                    </div>
                                                    <div className='front'>

                                                    {/* <a
                                                        href="javascript:void(0)"
                                                        // href={influence.AIC_CAMPAIGN_VIDEO_URL}
                                                        data-toggle="modal"
                                                        data-target="#quick-view"
                                                        data-video={influence.AIC_CAMPAIGN_VIDEO_URL}
                                                        onClick={() => this.onOpenModal(influence.AIC_CAMPAIGN_VIDEO_URL)}>
                                                        <div className="">
                                                            <img src={`${influence.AIC_CAMPAIGN_IMAGE_URL}`} alt="Avatar" className="w-100" />
                                                            {/* <div className="overlay">
                                                            <i className="fa fa-instagram" aria-hidden="true"></i>
                                                        </div> */}
                                                        {/* </div>
                                                    </a> */}
                                                      {/* <video
                                                        className={"responsive-video"}
                                                        preload={'false'}
                                                        autoPlay={true}
                                                        loop={true}
                                                        muted={true}
                                                        playsInline={true}
                                                        controls={true}
                                                        poster={""}
                                                    >
                                                        <source src={influence.AIC_CAMPAIGN_VIDEO_URL} />
                                                    </video>  */}
                                                    <ReactPlayer url={influence.AIC_CAMPAIGN_VIDEO_URL} playing  autoPlay={true} muted={true} controls width={'100%'} height={'100%'} /> 
                                                    </div>
                                                    {/* <span className="lable7">  {influence.AIC_CAMPAIGN_NAME} </span>   */}
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                            </Slider>
                        </div>
                    </div>
                </div>
                <Modal open={this.state.open} onClose={this.onCloseModal} center closeOnOverlayClick
                    classNames={{
                        overlay: 'customOverlay',
                        modal: 'customModal',
                    }}>
                    <ReactPlayer url={`${this.state.link}`} autoplay={true} playsInline={true} controls width={'100%'} height={'100%'} />
                </Modal>
            </section>
            }

            {/* Furniture Theme */}

            {
                themeLayoutId === 'L02' || themeLayoutId === 'L03'  &&
                <>
                <div className="title1  section-t-space">
                    {/* <h4>special offer</h4> */}
                    {/* <h2 className="title-inner1">{InfluencerText[0].APC_ELEMENT_CONTENT}</h2> */}
                </div>
                <section className="p-t-0">
                    <div className="container">
                        <div className="row">
                            <div className="col">
                                
                                <Slider {...topCategoryScrollAuto} className="product-4 product-m no-arrow">

                                    {influences.map((product, index) => {
                                        return (
                                            <div className="product-box">
                                                <div className="img-wrapper">
                                                    <div className="front">
                                                        {/* <Link to={`/${product.Link.APC_ACTION_TYPE}/${product.Link.APC_ACTION_URL}`}> */}
                                                            <img
                                                            src={`${
                                                                product.AIC_CAMPAIGN_IMAGE_URL ?
                                                                    product.AIC_CAMPAIGN_IMAGE_URL
                                                                    : product.SKU_IMAGE
                                                                }`}
                                                            className="img-fluid"
                                                            alt="" />
                                                            {/* </Link> */}
                                                    </div>
                                                </div>
                                                 <div className="product-detail">
                                                    <div>
                                                        <div className="rating text-center">
                                                            <h6>{product.AIC_CAMPAIGN_START_DT}</h6>
                                                            <h4>{product.AIC_CAMPAIGN_NAME}</h4>
                                                        </div>
                                                    </div>
                                                </div> 
                                                </div>
                                           )
                                    })
                                    }
                                </Slider>
                            </div>
                        </div>
                    </div>
                </section>
                </>
            }

            {/* end Furniture Theme */}
            </>
        )
    }
}

export default Influencer;